<template>
  <v-footer style="background: #3F3E40;" class="py-6" dark>
    <v-row justify="center" no-gutters>
      <v-col class="text-center">
        Yohann Hamonic - Photographies
      </v-col>
    </v-row>
  </v-footer>
  <!-- <v-row class="footer py-12" no-gutters>
      <v-col md="6" offset-md="3">
          <p class="text-center mb-0">Yohann Hamonic - Photographies</p>
      </v-col>
  </v-row> -->
</template>

<script>
export default {
  name: "pied",
};
</script>
